import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/resettime.png'


const _withScopeId = n => (_pushScopeId("data-v-5858e0f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checklist" }
const _hoisted_2 = { class: "filterarea" }
const _hoisted_3 = { class: "selecttime" }
const _hoisted_4 = { class: "checklistarea" }
const _hoisted_5 = { class: "refreshbox" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "checkcard-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "检查单号：", -1))
const _hoisted_9 = { class: "row-c" }
const _hoisted_10 = { class: "checkcard-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "检查单类型：", -1))
const _hoisted_12 = { class: "row-c" }
const _hoisted_13 = { class: "checkcard-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "检查类型：", -1))
const _hoisted_15 = { class: "row-c" }
const _hoisted_16 = { class: "checkcard-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "整改问题：", -1))
const _hoisted_18 = { class: "row-c" }
const _hoisted_19 = { class: "checkcard-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "检查单状态：", -1))
const _hoisted_21 = { class: "checkcard-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "检查人：", -1))
const _hoisted_23 = { class: "row-c" }
const _hoisted_24 = { class: "checkcard-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-t" }, "检查时间：", -1))
const _hoisted_26 = { class: "row-c" }
const _hoisted_27 = { class: "checkcard-row" }
const _hoisted_28 = { class: "row-t" }
const _hoisted_29 = { class: "row-c" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_dropdown_item, {
            modelValue: _ctx.billType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.billType) = $event)),
            options: _ctx.billTypes,
            onChange: _ctx.fChangeType
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.showCalendar = true))
        }, _toDisplayString(_ctx.selectDate), 1),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fSetTime && _ctx.fSetTime(...args)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_pull_refresh, {
          modelValue: _ctx.refreshing,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refreshing) = $event)),
          onRefresh: _ctx.onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: _ctx.loading,
              "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
              finished: _ctx.finished,
              "finished-text": "没有更多了",
              onLoad: _ctx.onLoad
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeRecordList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "checkcard",
                    key: index,
                    onClick: ($event: any) => (_ctx.goInfo(item))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, _toDisplayString(item.billNo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["checktype", {
                      _wrain: item.billType === 2,
                      _danger: item.billType === 3,
                    }])
                        }, _toDisplayString(item.billType === 1
                        ? "检查记录单"
                        : item.billType === 2
                        ? "隐患整改单"
                        : "停工整改单"), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.checkType === 1
                      ? "监督检查"
                      : item.checkType === 2
                      ? "企业检查"
                      : "项目检查"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.speechCode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", {
                        class: "row-c",
                        style: _normalizeStyle({
                    color: item.status === '2' ? '#d8d7de' : '#E3843C',
                  })
                      }, _toDisplayString(item.status === "0"
                      ? "待整改"
                      : item.status === "1"
                      ? "待审批"
                      : "已整改"), 5)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, _toDisplayString(item.checkUserName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, _toDisplayString(item.createTimestamp), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(item.status == "0" ? "整改责任人：" : "审批负责人："), 1),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(item.currentName), 1)
                    ])
                  ], 8, _hoisted_6))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished", "onLoad"])
          ]),
          _: 1
        }, 8, ["modelValue", "onRefresh"])
      ])
    ]),
    _createElementVNode("div", {
      class: "addbtn",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fGoAdd && _ctx.fGoAdd(...args)))
    }, [
      _createVNode(_component_van_icon, { name: "plus" })
    ]),
    _createVNode(_component_van_calendar, {
      "min-date": new Date('2019-01-01'),
      show: _ctx.showCalendar,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showCalendar) = $event)),
      onConfirm: _ctx.onConfirm
    }, null, 8, ["min-date", "show", "onConfirm"])
  ]))
}